import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber5 = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm-.03 12.043A2.674 2.674 0 0 1 5.12 9.959l1.283-.458A1.54 1.54 0 0 0 7.97 10.89a1.375 1.375 0 0 0 1.436-1.531 1.297 1.297 0 0 0-1.33-1.436 1.4 1.4 0 0 0-1.084.458H5.804l.211-4.343h4.392v1.236h-3.25l-.105 2.072c.394-.326.889-.505 1.4-.506a2.325 2.325 0 0 1 2.379 2.496 2.659 2.659 0 0 1-2.861 2.707z" />
    </g>
  );
};

export default withIcon(IconNumber5);
